import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { filter, map, take } from 'rxjs/operators';
import {
  ContractsResetBalanceAction,
  LoadAvailableContracts,
  LoadBalanceContracts,
} from '../../../actions/contracts.actions';
import { getAvailableProducts } from '../../../selectors/products.selectors';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

@Injectable()
export class LoadContractBalance implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store.dispatch(new ContractsResetBalanceAction());
    this.store
      .pipe(
        select(getAvailableProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) => products.find((product) => product.comm_product.comm_product.replace(/^0+/, '') === value)),
      )
      .subscribe((product) => {
        if (product) {
          this.store.dispatch(
            new LoadAvailableContracts({
              productCode: product.comm_product.comm_product.replace(/^0+/, ''),
              salesDocuments: product.comm_product.refDocuments,
            }),
          );
          return this.store.dispatch(new LoadBalanceContracts(product));
        }
      });
    if (!value) {
      this.store.dispatch(
        new LoadAvailableContracts({
          productCode: null,
          salesDocuments: null,
        }),
      );
    }
    formGroup.get(SpecFieldNames.CONTRACT_SELECT).setValue(undefined);
  }
}
